module.exports = {
    "sections": [
        {
            "name": "Proposed changes",
            "slug": "proposed-changes",
            "number": 1,

            "questions": [
                {
                    "label": "Which of the proposed localised changes to the project are you commenting on?",
                    "number": "1",
                    "name": "01-question",
                    "options": [
                        {
                            "label": "<strong>Additional land required at National Grid Electricity Transmission’s (NGET) proposed substation site (the Project’s National Grid Connection Point)</strong> (<a href='/proposals/overview-map/'>Click here</a> or refer to pages 10-11 of the targeted consultation brochure)",
                            "value": "National Grid Electricity",
                            "name" : "01-question-additional-1",
                            "number": 1
                        },
                        {
                            "label": "<strong>Adjustment of the onshore cable corridor from the PEIR boundary</strong> (<a href='/proposals/permanent-works/'>Click here</a> and <a href='/proposals/temporary-works/'>here</a> or refer to pages 10-11 and 12-15 of the targeted consultation brochure)",
                            "value": "Cable Corridor",
                            "name" : "01-question-additional-2",
                            "number": 2
                        },
                        {
                            "label": "<strong>Location of operation and maintenance (O&M) access points</strong> (<a href='/proposals/om-access-points/'>Click here</a> or refer to pages 10-11 and 16-19 of the of the targeted consultation brochure)",
                            "value": "Maintenance Access Points",
                            "name" : "01-question-additional-3",
                            "number": 3
                        },
                        {
                            "label": "<strong>Inclusion of construction traffic visibility splays</strong> (<a href='/proposals/onshore-cable-route/'>Click here</a> or refer to pages 10-11 and 20 of the targeted consultation brochure)",
                            "value": "Visibility Splays",
                            "name" : "01-question-additional-4",
                            "number": 4
                        },
                        {
                            "label": "<strong>Proposed locations of temporary construction compounds (TCCs)</strong> (<a href='/proposals/onshore-cable-route/#TCC'>Click here</a> or refer to pages 10-11 and 21 of the targeted consultation brochure)",
                            "value": "Temporary Construction Compounds",
                            "name" : "01-question-additional-5",
                            "number": 5
                        },
                        {
                            "label": "<strong>Improvements and widening of Bentley Road</strong> (<a href='/proposals/bentley-road-improvements/'>Click here</a> or refer to pages 22-25 of the targeted consultation brochure)",
                            "value": "Widen Bentley Road",
                            "name" : "01-question-additional-6",
                            "number": 6
                        }
                    ]
                }
            ]
        },
        {
            "name": "Your details",
            "slug": "your-details",
            "number": 2,

            "questions": [
                {
                    "number": "first_name",
                    "label": "First name",
                    "name": "first_name",
                    "required": true,
                    "type": "text",
                    "placeholder": "Enter your first name"
                },
                {
                    "number": "last_name",
                    "label": "Last name",
                    "name": "last_name",
                    "required": true,
                    "type": "text",
                    "placeholder": "Enter your last name"
                },
                {
                    "label": "Address",
                    "name": "address",
                    "required": true,
                    "type": "text",
                    "placeholder": "Enter your address"
                },
                {
                    "label": "Postcode",
                    "name": "postcode",
                    "required": true,
                    "type": "text",
                    "placeholder": "Enter your postcode"
                },
                {
                    "label": "Telephone number",
                    "name": "telephone",
                    "required": false,
                    "type": "tel",
                    "placeholder": "Enter your telephone number (optional)"
                },
                {
                    "label": "Email address",
                    "name": "email",
                    "required": true,
                    "type": "email",
                    "placeholder": "Enter your email"
                },
                {
                    "label": "Do you represent an organisation? If so, which one?",
                    "name": "organisation",
                    "required": false,
                    "type": "text",
                    "placeholder": "Enter organisation (optional)"
                },
                {
                    "label": "Do you wish to be kept updated on the project via email?",
                    "name": "progress",
                    "required": true,
                    "type": "radio",

                    "options": [
                        {
                            "label": "Yes",
                            "value": "yes"
                        },
                        {
                            "label": "No",
                            "value": "no"
                        }
                    ]
                },
            ]
        }
    ]
};